import request from '@/utils/request'
import { getCommunityId } from '@/api/community/communityApi'

// 查询收据列表
export function queryFeeReceipt(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/feeReceipt/queryFeeReceipt',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 按收据号批量修改同一单据号下的所有收据（公众号自缴缴款单把收据号直接改成发票号）
// 复用现有 updateFeeReceipt 接口（避免新增 serviceCode 触发 app 鉴权失败），
// service-fee 收到 receiptCodeForBatch 时走批量分支。
export function batchUpdateByReceiptCode(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/feeReceipt/updateFeeReceipt',
      method: 'post',
      data: {
        ...data,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 作废收据
export function voidFeeReceipt(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/feeReceipt/updateFeeReceipt',
      method: 'post',
      data: {
        ...data,
        statusCd: '2002',
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '作废收据失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询打印页面配置
export function listFeePrintPage(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/feePrintPage.listFeePrintPage',
      method: 'get',
      params: {
        ...params,
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 导出收据报表
export function exportFeeReceipt(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/export.exportData',
      method: 'get',
      params: {
        ...params,
        pagePath: 'exportFeeReceipt',
        communityId: getCommunityId()
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg))
      }
    }).catch(error => {
      reject(error)
    })
  })
}